/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import APICallService from '../../../../api/apiCallService'
import { AUTH } from '../../../../api/apiEndPoints'
import BankDetails from '../../../../app/modals/bank-details'

type HeaderUserMenuProps = {
  onChangePassword?: () => void
}

const HeaderUserMenu: FC<HeaderUserMenuProps> = ({ onChangePassword }) => {
  const { logout, currentUser } = useAuth()
  const [loading, setLoading] = useState(false)
  const [bankDetails, setBankDetails] = useState(false)

  const handleLogout = async () => {
    setLoading(true)
    let apiService = new APICallService(AUTH.LOGOUT)
    await apiService.callAPI()
    logout()
    setLoading(false)
  }

  return (
    <div className='absolute right-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50'>
      <BankDetails show={bankDetails} onHide={() => setBankDetails(false)} />

      {/* <Link
        to='profile-management/manage-profile'
        className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 no-underline'
      >
        Manage profile
      </Link> */}
      <div className='border-t border-gray-100 my-1' />
      <button
        onClick={() => onChangePassword?.()}
        className='w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 bg-transparent border-0 cursor-pointer'
      >
        Change password
      </button>
      <div className='border-t border-gray-100 my-1' />
      <button
        onClick={handleLogout}
        disabled={loading}
        className='w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 bg-transparent border-0 cursor-pointer disabled:opacity-50'
      >
        {loading ? (
          <span className='flex items-center gap-2'>
            <span className='w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin' />
            Logging out...
          </span>
        ) : (
          'Logout'
        )}
      </button>
    </div>
  )
}

export { HeaderUserMenu }
